import { createActionsHook, createContainer, createStateHook, createStore } from 'react-sweet-state';
import { actions } from './actions';
import { loadForms } from './actions/load-forms';
const AddFormStore = createStore({
  initialState: {
    isLoading: false,
    forms: null,
    error: null
  },
  actions,
  name: 'proforma-form-index-store'
});
export const useAddFormState = createStateHook(AddFormStore, {
  selector: state => ({
    isLoading: state.isLoading,
    forms: state.forms,
    error: state.error
  })
});
export const useAddFormActions = createActionsHook(AddFormStore);
export const useAddFormErrorUtils = createStateHook(AddFormStore, {
  selector: state => state.errorUtils
});
export const AddFormStoreContainer = createContainer(AddFormStore, {
  onInit: () => ({
    dispatch,
    setState
  }, {
    errorUtils
  }) => {
    setState({
      errorUtils
    });
    dispatch(loadForms());
  }
});